<template>
  <v-container>
    <v-layout text-center wrap>
      <v-flex xs12>
        Erreur 404
      </v-flex>

      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3">
          Cette page n'existe pas : 
        </h1>
        <p class="subheading font-weight-regular">
          Ce module n'est pas encore accessible ({{ $route.path }})
        </p>
      </v-flex>

      <v-flex mb-5 xs12 >
        <v-btn class="rounded-xl pa-5" large color="orange" :to="{ name: 'dashboard' }">Retour</v-btn>
      </v-flex>

      <v-flex xs12 mb-5 >
      </v-flex>

      <v-flex xs12 mb-5 >
        <h2 class="headline font-weight-bold mb-3">--</h2>
        <v-layout justify-center>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'error-component',

  data: () => ({

  }),
};
</script>